import { useAuth } from "hooks/auth";
import { Mixpanel } from "hooks/mixPanel";
import { toast } from "react-toastify";
import { sparketBlack } from "utils/constants";
import styles from "../styles.module.css";
import { ReactComponent as CopyLinkWhite } from "icons/copy-link-white.svg";
import Button from "react-bootstrap/Button";
import { getGroupState } from "state/slices/group-slice.ts";
import { useAppSelector } from "state/hooks.ts";

interface Props {
  url: string;
}

const CopyPoolButton = ({ url }: Props) => {
  const auth = useAuth();
  const isContestGroup = useAppSelector(getGroupState).isContestGroup;

  const copyMessage = isContestGroup
    ? "Contest link copied successfully"
    : "Pool link copied successfully";
  
  const copyToClipboard = async (text: string) => {
    if (!text || text.trim() === "") {
      throw new Error("No link available to copy");
    }
    
    // Use the modern clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        throw err;
      }
    } else {
      // Only use execCommand as a fallback if navigator.clipboard is not available
      try {
        const tempInput = document.createElement("input");
        tempInput.style.position = "absolute";
        tempInput.style.left = "-1000px";
        tempInput.style.top = "-1000px";
        tempInput.value = text;
        
        document.body.appendChild(tempInput);
        tempInput.select();
        
        const copyResult = document.execCommand("copy");
        document.body.removeChild(tempInput);
        
        if (!copyResult) {
          throw new Error("execCommand copy failed");
        }
        
        return true;
      } catch (error) {
        throw error;
      }
    }
  };
  
  return (
    <>
      <Button
        onClick={async () => {
          Mixpanel.track("Clicked Share Pool link", {
            isSignedIn: auth.signedIn,
          });
          
          try {
            await copyToClipboard(url);
            toast.success(copyMessage);
          } catch (error) {
            toast.error("Failed to copy link. Please try again.");
          }
        }}
        style={{
          height: 50,
          width: 50,
          backgroundColor: sparketBlack,
          border: "none",
        }}
      >
        <div className={styles.text}>
          <CopyLinkWhite style={{ height: 40, width: 40 }} />
        </div>
      </Button>
    </>
  );
};

export default CopyPoolButton;
